import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Phone, Mail, MapPin } from "lucide-react";

const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F7F2]" data-testid="impressum-page">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#7C9082] hover:text-[#6A7D70] transition-colors"
            data-testid="back-link"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-medium text-[#2C3329] mb-8">
            Impressum
          </h1>

          <div className="prose prose-lg max-w-none text-[#5C6658]">
            {/* Angaben gemäß § 5 TMG */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="bg-white rounded-xl p-6 border border-[#E5E0D8]">
                <p className="font-semibold text-[#2C3329] text-xl mb-2">DekoRent</p>
                <p className="mb-1">Karen Tappe</p>
                <p className="mb-1">Hessenring 21</p>
                <p className="mb-4">34246 Vellmar</p>
                
                <div className="space-y-2">
                  <div className="flex items-center gap-3">
                    <Phone className="h-5 w-5 text-[#7C9082]" />
                    <span>0176 34594053</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="h-5 w-5 text-[#7C9082]" />
                    <a href="mailto:info@dekorent-vellmar.de" className="text-[#7C9082] hover:underline">
                      info@dekorent-vellmar.de
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <MapPin className="h-5 w-5 text-[#7C9082]" />
                    <span>Vellmar & Umgebung</span>
                  </div>
                </div>
                
                <p className="mt-4 text-sm text-[#8C9688]">
                  <strong>Fax:</strong> 05615 7983988
                </p>
              </div>
            </section>

            {/* Kontakt */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Kontakt
              </h2>
              <p>
                Telefon: 0176 34594053<br />
                Telefax: 05615 7983988<br />
                E-Mail: info@dekorent-vellmar.de
              </p>
            </section>

            {/* Umsatzsteuer-ID */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Umsatzsteuer-ID
              </h2>
              <p>
                Kleinunternehmer gemäß § 19 UStG – es wird keine Umsatzsteuer ausgewiesen.
              </p>
            </section>

            {/* Verantwortlich für den Inhalt */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p>
                Karen Tappe<br />
                Hessenring 21<br />
                34246 Vellmar
              </p>
            </section>

            {/* Haftungsausschluss */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Haftungsausschluss
              </h2>
              
              <h3 className="text-xl font-medium text-[#2C3329] mt-6 mb-3">
                Haftung für Inhalte
              </h3>
              <p>
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die 
                Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch 
                keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG 
                für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
                Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, 
                übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>

              <h3 className="text-xl font-medium text-[#2C3329] mt-6 mb-3">
                Haftung für Links
              </h3>
              <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte 
                wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch 
                keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der 
                jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            {/* Urheberrecht */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Urheberrecht
              </h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen 
                Gebrauch gestattet.
              </p>
            </section>

            {/* Streitschlichtung */}
            <section className="mb-10">
              <h2 className="text-2xl font-medium text-[#2C3329] mb-4">
                Streitschlichtung
              </h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) 
                bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#7C9082] hover:underline">
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="mt-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="py-8 bg-[#2C3329] text-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-[#8C9688] text-sm">
            © {new Date().getFullYear()} DekoRent - Karen Tappe
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
